<template>
    <div>
        <div style="margin-bottom:15px">
            <el-button 
                type="success" 
                size="small"
                icon="el-icon-coordinate" 
                @click="signature()">
                    签章
            </el-button>
        </div>
          
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" min-width="220"></el-table-column>
            <el-table-column label="标段编码" prop="bdcode" min-width="200"></el-table-column>
            <el-table-column label="中标人" prop="tbdwname" min-width="220"></el-table-column>
            <el-table-column label="添加时间" prop="addtime" min-width="160"></el-table-column>
            <el-table-column label="状态" min-width="120">
                <template slot-scope="scope">
                    <my-tag type="warning" v-if="scope.row.shbj==='0'">未签章</my-tag>
                    <my-tag type="primary" v-if="scope.row.shbj==='1'">代理已签章</my-tag>
                    <my-tag type="success" v-if="scope.row.shbj==='2'">投标人已签章</my-tag>
                </template>
            </el-table-column>
            
            <el-table-column label="操作" fixed="right" min-width="160">
                <template slot-scope="scope">
                    <div v-if="scope.row.shbj!=='2'">
                        <my-btn type="edit" @click="edit(scope.row.guid)">修改</my-btn>
                        <my-btn type="del" @click="del(scope.row.guid)">删除</my-btn>
                    </div>
                    <div v-else>
                        <my-btn type="detail" @click="show(scope.row.guid)">查看</my-btn>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination 
            ref="page" 
            v-model="tableData" 
            :search="pgData" 
            :action="`${getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/seal/list.json`">
        </my-pagination>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
    },
    data() {
        return{
            pgData:{
                zbprocode:'',
                sortname : 'addtime',              
            },
            isreadshow:true,
            tableData:[],
            model:{},
            type:'xt',
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //删除
        del:function(guid){
            var that=this;         
            that.$post(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/seal/del.json`,{
                guid:guid
            }, (data, res) => {
                ShowMsg('删除成功', 'success');
                that.reloadHandler();
            }); 
        },
        //详情
        show:function(guid){
            this.goto({
                path:'./signatureDetail',
                query:{
                    guid:guid,
                }
            });
        },
        //修改
        edit:function(guid){
            this.goto({
                path:'./signatureForm',
                query:{
                    guid:guid,
                    zbprocode:this.getQuery('zbprocode'),
                }
            });
        },
        // 在线签章
        signature(){
            this.goto({
                path:'./signatureForm',
                query:{
                    zbprocode:this.getQuery('zbprocode'),
                }
            });
        }
    },
    created() {
        var that = this
        if(that.$route.query.zbprocode!=undefined){
            that.pgData.zbprocode=that.$route.query.zbprocode
        }
        that.jspInit(`${that.getGetters('mngUrl')}/DingBiao/ZbJgTzs/xingtai/listinit.json`,{
            zbprocode:that.getQuery('zbprocode'),
        }, data => {
            that.model = data.model
            if(that.model.ext3){
                that.type = 'zc'
            }else{
                if(that.getQuery('isXt')){
                    that.type = 'xt'
                }else{
                    that.type = 'common'
                }
            }
            console.log(that.type)
        });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
